import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
const authToken = process.env.REACT_APP_AUTH_TOKEN || null;
const apiVersion = "v3"

export const apiCall = async (
    method: "GET" | "POST" | "PUT" | "DELETE",
    path: string,
    body: any = null,
    token: string | null = null,
    headers: Record<string, string> = {},
    onProgress?: (progress: number) => void
  ) => {
    if (!token) {
      token = authToken; // Use default token if none provided
    }
  
    // Auto-detect FormData and prepare headers appropriately
    const isFormData = body instanceof FormData;
    const requestHeaders = {
      // Only set Content-Type for non-FormData requests
      ...(!isFormData && { "Content-Type": "application/json" }),
      ...(token && { Authorization: `Bearer ${token}` }),
      // Merge additional headers safely, but remove Content-Type if FormData
      ...Object.fromEntries(
        Object.entries(headers).filter(([key]) => 
          !(isFormData && key.toLowerCase() === 'content-type')
        )
      ),
    };
  
    const config = {
      method,
      url: `${BACKEND_URL}/api/${apiVersion}/${path}`,
      headers: requestHeaders,
      data: body,
      onUploadProgress: (progressEvent: any) => {
        if (onProgress) {
          // Safe progress calculation - guard against total being zero/undefined
          const percent = progressEvent?.total ? 
            Math.round((progressEvent.loaded / progressEvent.total) * 100) : 0;
          onProgress(percent);
        }
      },
    };
  
    try {
      const response = await axios(config);
      return response;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response;
        }
        throw error;
      }
      throw error;
    }
  };
